import { Graphics } from 'pixi.js';

interface FocusBtn { x: number; y: number; w: number; h: number; }

// Pulsing cyan focus ring around the keyboard-selected title menu button.
export function drawTitleFocusRing(g: Graphics, btn: FocusBtn | null): void {
  g.clear();
  if (!btn) return;
  const pulse = 0.6 + 0.4 * Math.sin(Date.now() * 0.006);
  g.roundRect(btn.x - 4, btn.y - 4, btn.w + 8, btn.h + 8, 12);
  g.stroke({ width: 2.5, color: 0x00ffcc, alpha: 0.85 * pulse });
  g.roundRect(btn.x - 8, btn.y - 8, btn.w + 16, btn.h + 16, 14);
  g.stroke({ width: 1.2, color: 0x00ffcc, alpha: 0.35 * pulse });
}
